import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';

@Component({
  selector: 'app-not-found',
  imports: [Card, Button, RouterLink, TranslatePipe],
  template: `
    <p-card [header]="'notFound.title' | translate">
      <p>{{ 'notFound.text' | translate }}</p>

      <p-button routerLink="/" [label]="'module.back' | translate" icon="pi pi-arrow-left" />
    </p-card>
  `,
  styles: `
    :host {
      display: block;
      max-width: 40rem;
      margin-inline: auto;
      padding: 2rem 1.5rem;
    }
  `,
})
export class NotFound {}
